import { ESSQuestionList, ESSSubQeustionList, InsepectionDetail, InspectionList } from "./state";

export function InitInspectionListAction(inspectionList:InspectionList[]){
    return {
        type: '@@inspectionState/InitInspectionListAction' as const ,
        inspectionList
    }
}

export function SelectedInspectionAction(inspectionDetail:InsepectionDetail,selected_inspection:InspectionList){
    return {
        type: '@@inspectionState/SelectedInspectionAction' as const ,
        inspectionDetail,
        selected_inspection
    }
}

export function ClearSelectedInspectionAction(){
    return {
        type: '@@inspectionState/ClearSelectedInspectionAction' as const 
    }
}

export function ChangeExcelStartDateAction(date:Date){
    return {
        type: '@@InspectionFormInfoState/ChangeExcelStartDateAction' as const ,
        date
    }
}

export function ChangeExcelEndDateAction(date:Date){
    return {
        type: '@@InspectionFormInfoState/ChangeExcelEndDateAction' as const ,
        date
    }
}

export function initInspectionQuestionAction(questionList:ESSQuestionList[]){
  return {
        type: '@@InspectionFormInfoState/initInspectionQuestionAction' as const ,
        questionList,
     
    }
}



export function ChangeSelectedInspectionAction(selected_inspection:InspectionList){
     return {
        type: '@@InspectionFormInfoState/ChangeSelectedInspectionAction' as const ,
        selected_inspection
    }
}

export function InitInspectionSubQuestionAction(subQuestionList:ESSSubQeustionList[]){
    return {
        type: '@@inspectionState/InitInspectionSubQuestionAction' as const ,
        subQuestionList
    }
}

export function ChangeInspectionQuestionParentIdAction(selected_parent_question_id:number){
 return {
        type: '@@inspectionState/ChangeInspectionQuestionParentIdAction' as const ,
        selected_parent_question_id
    }
}


export type InspectionAction =

|ReturnType<typeof InitInspectionListAction>
|ReturnType<typeof SelectedInspectionAction>
|ReturnType<typeof ClearSelectedInspectionAction>
|ReturnType<typeof ChangeExcelStartDateAction>
|ReturnType<typeof ChangeExcelEndDateAction>
|ReturnType<typeof initInspectionQuestionAction>
|ReturnType<typeof ChangeSelectedInspectionAction>
|ReturnType<typeof InitInspectionSubQuestionAction>
|ReturnType<typeof ChangeInspectionQuestionParentIdAction>